module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            如需新增、修改菜單內容，請至\n            "), _c('router-link', {
    attrs: {
      "to": {
        name: _vm.goStepViewInfo.name,
        params: _vm.goStepViewInfo.params
      }
    },
    domProps: {
      "textContent": _vm._s(_vm.goStepViewInfo.title)
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.goToCrMenu
    }
  }, [_vm._v("\n                    新增菜單\n                  ")])]), _vm._v(" "), (!_vm.isStore) ? _c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'crStoreClass',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("\n                      門市群組\n                    ")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isStore) ? _c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'MenuSettingRuleStoreCopyView',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("菜單同步權限設定")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isStore) ? _c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'MenuSettingRuleStoreUpdateView',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("菜單編輯權限設定")])])], 1) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.menuList.length) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.menuList), function(menu, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.goToMenuInfo(menu.menu_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bars",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(index + 1)
      }
    })])]), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.menu_id)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.name)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.ver_stamp)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.description)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.remark)
      }
    }), _vm._v(" "), _c('td', [(!menu.is_locked) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (menu.is_locked) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("鎖定")]) : _vm._e()]), _vm._v(" "), _c('td', [(menu.status == 1) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("編輯中")]) : _vm._e(), _vm._v(" "), (menu.status == 2) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("編輯完畢")]) : _vm._e()]), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.ver_time)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.update_time)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(menu.create_time)
      }
    }), _vm._v(" "), _c('td', [(menu.is_locked) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.menuUnlock(menu.menu_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lock",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (!menu.is_locked && menu.status === 2) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.menuLock(menu.menu_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-unlock-alt",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [(!menu.is_locked) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.goToUpMenu(menu.menu_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [(menu.status == 2) ? _c('button', {
      staticClass: "btn btn-primary",
      domProps: {
        "textContent": _vm._s('複本')
      },
      on: {
        "click": function($event) {
          return _vm.goToCrMenu({
            menu: menu,
            type: 1
          }, 1111)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(menu.is_locked) ? _c('button', {
      staticClass: "btn bg-black",
      domProps: {
        "textContent": _vm._s('上架')
      },
      on: {
        "click": function($event) {
          return _vm.goToCrSchedule(menu)
        }
      }
    }) : _vm._e()])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [(_vm.pageAmount > 1 && _vm.pageGroup !== 1) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup - 1
      }
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.getMenuList(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), (_vm.pageAmount > 1 && _vm.pageAmount / _vm.groupAmount > _vm.pageGroup) ? _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        _vm.pageGroup = _vm.pageGroup + 1
      }
    }
  }, [_vm._m(3)]) : _vm._e()], 2)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("代碼")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("時間")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("菜單ID")]), _vm._v(" "), _c('th', [_vm._v("名稱")]), _vm._v(" "), _c('th', [_vm._v("版本碼")]), _vm._v(" "), _c('th', [_vm._v("描述")]), _vm._v(" "), _c('th', [_vm._v("備註")]), _vm._v(" "), _c('th', [_vm._v("鎖定")]), _vm._v(" "), _c('th', [_vm._v("狀態")]), _vm._v(" "), _c('th', [_vm._v("版本時間")]), _vm._v(" "), _c('th', [_vm._v("修改時間")]), _vm._v(" "), _c('th', [_vm._v("建立時間")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e822213"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/menu-build.vue
// module id = 2413
// module chunks = 1